import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
const colours = [
    '#1abc9c',
    '#2ecc71',
    '#3498db',
    '#9b59b6',
    '#34495e',
    '#16a085',
    '#27ae60',
    '#2980b9',
    '#8e44ad',
    '#2c3e50',
    '#e67e22',
    '#e74c3c',
    '#ecf0f1',
    '#95a5a6',
    '#f39c12',
    '#d35400',
    '#c0392b',
];
class LetterAvatar extends Component {
    constructor(props) {
        super(props);
        const randomIndex = Math.floor(Math.random() * colours.length);
        this.state = {
            backgroundColor: colours[randomIndex],
        };
    }
    render() {
        const { user: { initials, name }, overlapping, } = this.props;
        const { backgroundColor } = this.state;
        const style = {
            backgroundColor,
        };
        const className = classnames({
            flex: true,
            'h-10': true,
            'items-center': true,
            'justify-center': true,
            '-mr-2': overlapping,
            rounded: true,
            'rounded-full': true,
            'w-10': true,
        });
        const title = name || initials;
        return (React.createElement("div", { className: className, style: style, title: title },
            React.createElement("div", { className: "text-white text-center" }, initials)));
    }
}
LetterAvatar.propTypes = {
    user: PropTypes.shape({
        initials: PropTypes.string,
        name: PropTypes.string,
    }).isRequired,
    overlapping: PropTypes.bool,
};
LetterAvatar.defaultProps = {
    overlapping: false,
};
export default LetterAvatar;
